import React from "react";
import ReactImageFallback from "react-image-fallback";
import styled from "styled-components";

import FallbackImage from "../../../assets/fallback.png";
import DeleteSrc from "../../../assets/trash.svg";
import EditSrc from "../../../assets/pencil.svg";

const Container = styled.div`
  width: 49%;
  height: 125px;
  background: white;
  margin: 0 1% 1% 0;
  border-radius: 5px;
`;
const ImageContainer = styled.div`
  width: 28%;
  height: 90%;
  background: white;
  float: left;
  margin: 1.1%;
  text-align: center;
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  object-fit: cover;
`;
const DetailsContainer = styled.div`
  width: 68%;
  height: 100%;
  float: right;
`;
const Details = styled.div`
  width: 80%;
  height: 100%;
  float: left;
`;
const Name = styled.h3`
  font-size: 1em;
  margin: 0;
  padding: 4% 0 1% 0;
  font-weight: 500;
`;
const Measurement = styled.p`
  margin: 0;
  padding: 0 0 5% 0;
  color: gray;
`;
const Price = styled.button`
  margin: 0;
  padding: 5px 10px;
  background: #ff5d5d;
  color: white;
  border: none;
  border-radius: 5px;
`;
const Actions = styled.div`
  width: 20%;
  height: 100%;
  float: right;
  text-align: center;
`;
const EditButton = styled.button`
  display: block;
  margin: 80% 0 5% 20%;
  background: white;
  padding: 6px 8px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  background: #f5f5f5;
  border: none;
`;

const ButtonImage = styled.img`
  width: 14px;
  height: 14px;
`;
const Product = (props) => {
  return (
    <Container>
      <ImageContainer>
        {/* <Image src={props.product.images[0]} alt="product name" /> */}
        <ReactImageFallback
          src={props.product.images[0]}
          fallbackImage={FallbackImage}
          initialImage={FallbackImage}
          alt="cool image should be here"
          className="my-product-image"
        />
      </ImageContainer>
      <DetailsContainer>
        <Details>
          <Name>{props.product.name}</Name>
          <Measurement>{props.product.measurment}</Measurement>
          <Price>{props.product.price} tk</Price>
        </Details>
        <Actions>
          <EditButton>
            <ButtonImage
              onClick={() => {
                props.editHandler(props.index);
              }}
              src={EditSrc}
              alt="Edit"
            />
          </EditButton>
          {/* <DeleteButton onClick={()=>props.cancelModaHandler(props.product._id)}>
                       <ButtonImage src={DeleteSrc} alt="Delete"/>
                   </DeleteButton> */}
        </Actions>
      </DetailsContainer>
    </Container>
  );
};

export default Product;
